import React, { useEffect } from 'react';
import print from '../../../images/mokup.png'
import '../../../index.css'
import './Banners.css'
import { useNavigate } from 'react-router-dom';

function Banner(){
    const navigate = useNavigate();
    useEffect(() => {
            const handleKeyPress = (event) => {
              switch (event.key) {
                case "F1":
                  event.preventDefault();
                  navigate("/app/listapedidos");
                  break;
                default:
                  break;
              }
            };
        
            document.addEventListener("keydown", handleKeyPress);
            return () => {
              document.removeEventListener("keydown", handleKeyPress);
            };
          }, [navigate]);
    return <section id="banner">
    <div className="container">
        <div className="row align-items-center h-100 mb-5">
            <div className="col-lg-6 col-md-12 text-center text-lg-start ">
                <h1>SRI web</h1>
                <h4>
                    O SRI-web oferece desde a organização e centralização de informações, análise de dados em tempo real. Essa solução é essencial para melhorar a eficiência operacional, aumentar a produtividade e impulsionar o crescimento sustentável das empresas.
                </h4>
                <h4> Pressione a tecla F1 para ir a página de vendas!</h4>
            </div>
            <div className="col-lg-6 col-md-12 text-center mb-5">
                <img src={print} alt="SRI Web Preview" className="img-fluid" />
            </div>
        </div>
    </div>
</section>


}



export default Banner;